import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const OrganizationsILove: React.FC = () => {
  const partnerLogos = [
    { name: 'Equal Justice Initiative', logo: '/logos/org1.png' },
    { name: 'Animal Equality', logo: '/logos/org2.png' },
    { name: 'Farm Sanctuary', logo: '/logos/org3.png' },
    { name: 'The Humane League', logo: '/logos/org4.png' },
  ];

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            fontWeight: 900,
            fontFamily: '"Impact", sans-serif',
            mb: 4,
            textTransform: 'uppercase',
          }}
        >
          ORGANIZATIONS I LOVE
        </Typography>

        {/* Description Text */}
        <Typography
          sx={{
            fontSize: { xs: '1.125rem', md: '1.25rem' },
            lineHeight: 1.8,
            mb: 8,
            maxWidth: '1200px',
          }}
        >
          I do my best to use my platform to elevate organizations that are giving back to animals, our 
          communities, and the environment. I'm committed to donating a significant percentage of our 
          revenue to impactful organizations.
        </Typography>

        {/* Partner Logos */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: { xs: 4, md: 6 },
          }}
        >
          {partnerLogos.map((partner, index) => (
            <Box
              key={index}
              sx={{
                height: { xs: '50px', md: '60px' },
                flex: { xs: '1 1 45%', md: '1 1 18%' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                loading="lazy"
                decoding="async"
                width="200"
                height="60"
                style={{
                  height: '100%',
                  width: 'auto',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default OrganizationsILove;